export default __webpack_public_path__ + "static/Concept_2-9766471ebe14b9e935964eb3b131ec1e.jpg";